import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/data/site";

export default function Expertise() {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="relative bg-[#08080A] text-white py-24 lg:py-32 overflow-hidden"
    >
      <div
        className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#F5A623]/[0.08] blur-3xl"
        aria-hidden
      />
      <div
        className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#F5A623]/[0.05] blur-3xl"
        aria-hidden
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[#F5A623] font-semibold">
            <span className="divider-gold" /> Areas of Expertise
          </span>
          <h2
            data-testid="expertise-headline"
            className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight silver-text"
          >
            Specialised plans for the situations <em className="text-[#F5A623]">most advisors miss.</em>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {SITE.expertise.map((e, i) => (
            <motion.article
              key={e.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group relative glass-card rounded-md p-8 hover:-translate-y-1 transition-all duration-300"
              data-testid={`expertise-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-serif text-5xl text-[#F5A623]/30">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <ArrowUpRight className="w-5 h-5 text-[#F5A623] opacity-50 group-hover:opacity-100 transition-opacity" />
              </div>
              <h3 className="mt-6 font-serif text-2xl text-white">{e.title}</h3>
              <p className="mt-3 text-sm text-[#B7BBC4] leading-relaxed">{e.body}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
